import axios from "axios";
import Cookies from "universal-cookie";
import { Login } from "../common/login";
const apiUrl = process.env.REACT_APP_API_URL;

const cookies = new Cookies();

export const getAllBalanceTransfer = async (
  banktransferId: string,
  url: string,
  filters: {
    year?: string;
    month?: string;
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
    donationTypeId?: string;
    donationPurposeId?: string;
  }
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/balancetransfer/getall`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        banktransferId,
        year: filters.year || '',
        month: filters.month || '',
        searchTerm: filters.searchTerm || '',
        pageNumber: filters.pageNumber || 1,
        pageSize: filters.pageSize || 10,
        donationTypeId: filters.donationTypeId || '',
        donationPurposeId: filters.donationPurposeId || '',
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export async function addBalanceTransfer(
  url: string,
  transferaccountFrom: string,
  transferFrom: string,
  transferTo: string,
  transferaccountTo: string,
  donationPurposeId: string,
  donationTypeId: string | null,
  Amount: number,
  TransferedOn: string,
  desc: string,
  TransferToBankStatementId: string,
  TransferFromBankStatementId: string
) {
  const token = cookies.get("authToken");
  
  try {
    const response = await axios.post(
      `${url}/balancetransfer/create`,

      {
        transferaccountFrom,
        transferFrom,
        transferTo,
        transferaccountTo,
        donationPurposeId,
        donationTypeId,
        Amount,
        TransferedOn,
        desc,
        TransferToBankStatementId,
        TransferFromBankStatementId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}

export async function updateBalanceTransfer(
  url: string,
  Id: string,
  transferaccountFrom: string,
  transferFrom: string,
  transferTo: string,
  transferaccountTo: string,
  donationPurposeId: string,
  donationTypeId: string | null,
  Amount: number,
  TransferedOn: string,
  desc: string
) {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${url}/balancetransfer/update`,
      {
        Id,
        transferaccountFrom,
        transferFrom,
        transferTo,
        transferaccountTo,
        donationPurposeId,
        donationTypeId,
        Amount,
        TransferedOn,
        desc,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
}

export const getBalanceTransferById = async (
  id: string,
  url: string
): Promise<any> => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.get(`${url}/balancetransfer/getbyid`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        id,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);

    return false;
  }
};

export const updateBankStatementIdBalanceTransfer = async (
  balanceTransferIds: string[],
  TransferFromBankstatementId: string,
  TransferToBankstatementId: string
) => {
  const token = cookies.get("authToken");
  const requestBody: any = {
    TransferFromBankstatementId: TransferFromBankstatementId,
    TransferToBankstatementId: TransferToBankstatementId,
    balanceTransferIds: balanceTransferIds,
  };

  try {
    const response = await axios.patch(
      `${apiUrl}/balanceTransfer/updateBankstatementId`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getAssignedBalanceTransfer = async (
  CRstatementId: string | null,
  DRstatementId: string | null
): Promise<any> => {
  const token = cookies.get("authToken");
  const response = await axios.get(`${apiUrl}/balanceTransfer/getassignedbalancetransfer`, {
    headers: { Authorization: `Bearer ${token}` },
    params: {
      CRstatementId,
      DRstatementId
    }
  });
  return response.data;
};


export const UnAssignBSIdBalanceTransfer = async (Id: string) => {
  const token = cookies.get("authToken");
  try {
    const response = await axios.post(
      `${apiUrl}/balanceTransfer/unAssignBankstatementId/${Id}`,
      {}, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("response", response.data);
    return response.data;
  } catch (error) {
    console.error("Error in UnAssignBSIdBalanceTransfer:", error);
    throw error;
  }
};
